import { TreeService } from 'business/services/TreeService';
import { BaseTreeDataSupplier } from './BaseTreeDataSupplier';

class TreeDataSupplier implements BaseTreeDataSupplier {
  async getTreeNodes(id: any, validTreeNodesTypes?: string[], signal?: AbortSignal) {
    const ser: TreeService = new TreeService();
    const children = await ser.getTreeNodesService(id, validTreeNodesTypes, signal);

    if (children === null) {
      return null;
    }

    return children;
  }
}

export class EagerLoadTreeDataSupplier implements BaseTreeDataSupplier {
  async getTreeNodes(id?: any, validTreeNodesTypes?: string[], signal?: AbortSignal) {
    const ser: TreeService = new TreeService();
    return await ser.getAllTreeNodesService(validTreeNodesTypes, signal);
  }
}

export default TreeDataSupplier;
